import { Box, Container, Tab, Tabs } from "@mui/material";
import React, { useEffect, useState } from "react";
import TopBar from "./components/Topbar";
import { PO_Backlog_Service } from "../../redux/po_backlog/po_backlog.services";
import TabContent from "./components/TabContent";
import SnackbarWithMessage from "../../common/components/Snackbars/SnackbarWithMessage";

const ProductionPlannerHome = () => {
  const [tabValue, setTabValue] = useState(0);
  const [tabs, setTabs] = useState([]);
  const [open_snackbar_with_message, set_open_snackbar_with_message] = useState({
    open: false,
    message: "",
    severity: "info"
  });
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const fetchTabs = async () => {
    try {
      const result = await PO_Backlog_Service.sample_types_get();
      console.log(result);

      if (Array.isArray(result?.data?.data)) {
        setTabs(result?.data?.data);
      } else if (typeof result?.data?.data === "object") {
        setTabs(Object.keys(result.data?.data));
      } else {
        console.error("Unexpected data structure:", result?.data);
        setTabs([]);
      }
    } catch (error) {
      console.error(error);
      setTabs([]);
    }
  };

  useEffect(() => {
    fetchTabs();
  }, []);

  return (
    <Box className="">
      {/* snackbar */}
      <SnackbarWithMessage {...open_snackbar_with_message} onClose={() => {
        set_open_snackbar_with_message({
          open: false,
          message: "",
          severity: "info"
        });
      }} />
      <Box className="flex flex-col gap-3 p-2">
        <TopBar />
      </Box>
      <Container maxWidth="xl">
        <Box className="flex justify-between items-baseline">
          <Tabs
            className="flex-1"
            sx={{
              borderBottom: "1px solid #e8e8e8",
              "& .MuiTabs-indicator": {
                backgroundColor: "#084298",
                display: "flex",
                justifyContent: "center",
              },
              "& .MuiTabs-indicatorSpan": {
                maxWidth: 40,
                width: "100%",
                // backgroundColor: '#635ee7',
              },
            }}
            value={tabValue}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons={false}
            aria-label="scrollable prevent tabs example"
          >
            {tabs?.map((tab, index) => (
              <Tab key={index} disableRipple label={(tab === "CB" ? "In Process" : tab === "FP" ? "FP Pack" : tab)} />
            ))}
          </Tabs>
          <Box></Box>
        </Box>
        {/* Render content based on the selected tab */}
        {tabs?.length > 0 && <TabContent tabName={tabs[tabValue]} set_open_snackbar_with_message={set_open_snackbar_with_message} />}
      </Container>
    </Box>
  );
};

export default ProductionPlannerHome;
